import { useEffect, useState } from 'react';
import { Select } from '@mantine/core';

interface CountrySelectProps {
  form: any;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export function CountrySelect({
  form,
  label = 'Country',
  placeholder = 'Select a country',
  disabled
}: CountrySelectProps) {
  const [countries, setCountries] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch('https://restcountries.com/v3.1/all?fields=name');
        const data = await res.json();

        const sortedCountries = data
          .map((c: any) => ({
            value: c.name.common,
            label: c.name.common
          }))
          .sort((a: any, b: any) => a.label.localeCompare(b.label));

        setCountries([{ value: '', label: '' }, ...sortedCountries]);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchCountries();
  }, []);

  const selectedCountry = form.values.country || '';

  return (
    <Select
      label={label}
      placeholder={placeholder}
      data={countries}
      searchable
      clearable
      value={selectedCountry}
      onChange={value => form.setFieldValue('country', value || '')}
      error={form.errors.country}
      disabled={disabled}
    />
  );
}
